module.exports = "/_next/static/images/parallax-6-4ed2455bccbddcae511ca21e3443eb0b.jpg.webp";